<ng-container *ngIf="selectedPaymentMethod && fields">
<h3 class="payment-cashier--detailsTitle">{{'customCashier.paymentDetails' | translate}}</h3>
<app-saved-cards [selectedPaymentMethod]="selectedPaymentMethod"></app-saved-cards>
<ng-container *ngIf="selectedPaymentMethod && fields && isNewFormEnabled">
    <app-dynamic-form [fields]="getFields()" (updateFormData)="updateFormData($event)" [oneLineInputFields]="oneLineInputsData"></app-dynamic-form>
</ng-container>
    
</ng-container>
